'use client';

import Carousel, { CarouselItem } from '@/components/@base/carousel';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';

import { DATA_CY_ABOUT_EXTRA_PRODUCT, DATA_CY_ABOUT_EXTRA_PRODUCTS } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

import Banner from './banner';

export default function ExtraProduct() {
  const {
    content: { aboutUs: aboutUsLocalization },
  } = pageLevelLocalization;

  return (
    <Container className='bg-[#1B1B1B] py-10'>
      <Container
        data-cy={DATA_CY_ABOUT_EXTRA_PRODUCTS}
        className='max-w-[1279px] *:w-full md:mx-auto'
      >
        <Container className='my-10 flex flex-col items-center'>
          <Heading
            type={HEADING_TYPE.H2}
            className='text-[26px] leading-9 font-medium tracking-tighter text-[#F7F8F9]'
          >
            {aboutUsLocalization.extra_products}
          </Heading>
          <Text
            type={TEXT_TYPE.P}
            className='mt-2 text-base leading-5 font-light tracking-tighter text-[#878F9B]'
          >
            {aboutUsLocalization.benefits.why_we_are_the_best}
          </Text>
        </Container>
        <Carousel
          spaceBetween={50}
          slidesPerView={1}
          maxBackfaceHiddenSlides={0}
          breakpoints={{
            768: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          }}
        >
          <CarouselItem data-cy={DATA_CY_ABOUT_EXTRA_PRODUCT}>
            <Banner
              link='https://www.herobox.ir/'
              image={imagesList.images.hero_box_Banner}
              alt='hero box'
            />
          </CarouselItem>
          <CarouselItem data-cy={DATA_CY_ABOUT_EXTRA_PRODUCT}>
            <Banner
              link='https://service.zhaket.com/'
              image={imagesList.images.zhaket_services_Banner}
              alt='wordpress services'
            />
          </CarouselItem>
          <CarouselItem data-cy={DATA_CY_ABOUT_EXTRA_PRODUCT}>
            <Banner
              link='https://academy.zhaket.com/'
              image={imagesList.images.zhaket_academy_Banner}
              alt='academy'
            />
          </CarouselItem>
        </Carousel>
      </Container>
    </Container>
  );
}
